export const REQUIRED_FIELD_MESSAGE = 'Поле обязательно для заполнения'
